/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import BackAction from './BackAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import Title from './Title/index'
import TysiaIconInfoFilled from 'DesignSystem/Svgs/TysiaIconInfoFilled/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useListItemDataOnChange from './useListItemDataOnChange.js'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Phone/NewPhone/Content/SearchForPhone/Content/Content"
  
}) {
let dtColorsBlue100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.100'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsBlue700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.700'
        })
let newPhonePhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'new_phone',
path: 'phone.number',
format: fromFormat.phoneNumberUS,
})
let dtTypographySizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.size.m'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtColorsBlue600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.600'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsBlue100,'--bblr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-6-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pt-7-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-8-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-9-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mb-10-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconInfoFilled
  viewPath={`${viewPath}/TysiaIconInfoFilled`}
 fill={dtColorsBlue700}
 marginRight={dtSpaceS}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtTypographySizeM}
 fontWeight={500}
 color={dtColorsBlue700}
 data="new_phone.phone.number"
 format="/Data/format.js phoneNumberUS"
 text={newPhonePhoneNumberValueData}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtTypographyFontsizeM}
 color={dtColorsBlue600}
 text="There are other people currently associated with this phone."
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mt-6-Z1Yf8zk': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal2}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
</div>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}